namespace GeniuzPOS.RefundReasonReport {
    export class ReportRefundReasonSumBillDtColumns {
        static columnsKey = 'RefundReasonReport.ReportRefundReasonSumBillDt';
    }
}
